import { useLayoutEffect, useCallback } from 'react';
import { useResizeObserver } from '../internal/hooks/container-queries/use-resize-observer';
import { CONTAINER_ROOT_BORDER, useSupportsStickyHeader } from '../container/use-sticky-header';
import stickyScrolling, { calculateScrollingOffset, scrollUpBy } from './sticky-scrolling';
function syncSizes(from, to) {
    var fromCells = Array.prototype.slice.apply(from.children);
    var toCells = Array.prototype.slice.apply(to.children);
    for (var i = 0; i < fromCells.length; i++) {
        // prefer the inline style if it set
        toCells[i].style.width = fromCells[i].style.width || fromCells[i].offsetWidth + "px";
    }
}
export var useStickyHeader = function (theadRef, secondaryTheadRef, secondaryTableRef, tableWrapperRef, stickyHeader) {
    var getPrimaryThead = useCallback(function () { return theadRef.current; }, [theadRef]);
    // Sync the sizes of the column header copies in the sticky header with the originals
    var syncColumnHeaderWidths = useCallback(function () {
        if (stickyHeader &&
            theadRef.current &&
            secondaryTheadRef.current &&
            secondaryTableRef.current &&
            tableWrapperRef.current) {
            syncSizes(theadRef.current, secondaryTheadRef.current);
            secondaryTableRef.current.style.width = theadRef.current.offsetWidth + "px";
            tableWrapperRef.current.style.marginTop = "-" + theadRef.current.offsetHeight + "px";
        }
    }, [stickyHeader, theadRef, secondaryTheadRef, secondaryTableRef, tableWrapperRef]);
    useLayoutEffect(function () {
        syncColumnHeaderWidths();
        /* eslint-disable-next-line no-warning-comments */
        // Content is not going to be layed out until the next frame in angular,
        // so we need to sync the column headers again.
        setTimeout(function () { return syncColumnHeaderWidths(); }, 0);
        var secondaryTable = secondaryTableRef.current;
        var primaryTable = tableWrapperRef.current;
        return function () {
            if (secondaryTable) {
                secondaryTable.style.width = '';
            }
            if (primaryTable) {
                primaryTable.style.marginTop = '';
            }
        };
    });
    useResizeObserver(getPrimaryThead, syncColumnHeaderWidths);
    var supportsStickyHeader = useSupportsStickyHeader();
    var scrollToTop = function () {
        if (stickyHeader &&
            supportsStickyHeader &&
            theadRef.current &&
            secondaryTheadRef.current &&
            tableWrapperRef.current) {
            var scrollDist = calculateScrollingOffset(theadRef.current, secondaryTheadRef.current, CONTAINER_ROOT_BORDER);
            if (scrollDist > 0) {
                scrollUpBy(scrollDist, tableWrapperRef.current);
            }
        }
    };
    var scrollToItem = stickyScrolling(tableWrapperRef, secondaryTheadRef, CONTAINER_ROOT_BORDER).scrollToItem;
    var scrollToRow = function (itemNode) {
        if (stickyHeader && supportsStickyHeader) {
            scrollToItem(itemNode);
        }
    };
    return { scrollToRow: scrollToRow, scrollToTop: scrollToTop };
};
//# sourceMappingURL=use-sticky-header.js.map